import { useIsModernizedSegmentationPageEnabled } from 'modules/segmentation/hooks';
import styled from 'styled-components';
import { Link } from 'ui/links';
import { spacing } from 'ui/theme';

type ViewListLinkProps = {
  id: string;
  value: string;
};

const StyledLink = styled(Link)`
  margin-top: ${spacing.threeQuarter};
`;

export const ViewListLink = ({ id, value }: ViewListLinkProps) => {
  const isModernizedSegmentationPageEnabled = useIsModernizedSegmentationPageEnabled();
  return (
    <StyledLink
      hasOpenNewTabIcon
      data-test={id}
      target="_blank"
      href={`/segmentation?emailListId=${value}`}
      rel="noreferrer noopener"
      useReactRouter={isModernizedSegmentationPageEnabled}
    >
      View list
    </StyledLink>
  );
};
